import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Communities } from './pages/Communities';
import { Collective } from './pages/Collective';
import { Buyers } from './pages/Buyers';
import { Sellers } from './pages/Sellers';
import { Contact } from './pages/Contact';
import { DealFlowLayout } from './dealflow/DealFlowLayout';
import { DealFlowHome } from './dealflow/DealFlowHome';
// Scroll to top on route change
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2wj8cjlweui34">
      <ScrollToTop data-id="element-1" data-mp="2wip54z4dzc3c" />
      <Routes data-id="element-2" data-mp="2wi5l9cv6edmo">
        {/* DealFlow Routes */}
        <Route path="/dealflow" element={<DealFlowLayout data-id="element-4" data-mp="23vkwmk634fmt">
              <DealFlowHome data-id="element-5" data-mp="23u9tmmkgrbwr" />
            </DealFlowLayout>} data-id="element-3" data-mp="28te2td7e19n3" />

        {/* CaboCollection Routes */}
        <Route path="/*" element={<Layout data-id="element-7" data-mp="3mlaxj7fckftz">
              <Routes data-id="element-8" data-mp="3mkhlps1j704z">
                <Route path="/" element={<Home data-id="element-10" data-mp="3mj6ibtbzzuee" />} data-id="element-9" data-mp="3mjzu58ptda3e" />
                <Route path="/communities" element={<Communities data-id="element-12" data-mp="3rdkg22e4udm8" />} data-id="element-11" data-mp="3rcj2nr9n9f1c" />
                <Route path="/collective" element={<Collective data-id="element-14" data-mp="6hq1ea16ddl" />} data-id="element-13" data-mp="3reltgdimfc74" />
                <Route path="/buyers" element={<Buyers data-id="element-16" data-mp="7suzhf7pr6a" />} data-id="element-15" data-mp="5gel8p3rovc" />
                <Route path="/sellers" element={<Sellers data-id="element-18" data-mp="2zmenq84nlk7i" />} data-id="element-17" data-mp="2zllen0i82im7" />
                <Route path="/contact" element={<Contact data-id="element-20" data-mp="33mf6g4yschkd" />} data-id="element-19" data-mp="2zn6cp03qwjot" />
              </Routes>
            </Layout>} data-id="element-6" data-mp="3ij61y35c994p" />
      </Routes>
    </BrowserRouter>;
}